import { makeStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#F6F8FA",
    marginLeft: 180,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 80,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  headerContainer: {
    marginBottom: theme.spacing(4),
  },
  dashboardTitle: {
    fontSize: "1.75rem",
    fontWeight: 600,
    color: theme.palette.darkGrey.main,
    marginBottom: theme.spacing(1),
  },
  dashboardSubtitle: {
    color: "#697386",
    fontSize: "0.875rem",
  },
  visitorOverview: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
  },
  periodSelector: {
    display: "flex",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  periodButton: {
    padding: theme.spacing(1, 2),
    border: "none",
    borderRadius: theme.spacing(0.5),
    backgroundColor: "transparent",
    color: "#697386",
    cursor: "pointer",
    fontSize: "0.875rem",
    fontFamily: "inherit",
    lineHeight: 1.5,
    transition: "background-color 0.2s ease, color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(35, 44, 72, 0.06)",
    },
    "&:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  periodButtonActive: {
    backgroundColor: "rgba(35, 44, 72, 0.08)",
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  visitorChart: {
    height: 250,
    position: "relative",
  },
  statsBlock: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: theme.spacing(3),
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  chartContainer: {
    height: "300px",
    width: "100%",
    flex: 1,
    position: "relative",
    marginTop: theme.spacing(2),
  },
  title: {
    fontSize: "1.125rem",
    fontWeight: 500,
    color: theme.palette.darkGrey.main,
    marginBottom: theme.spacing(1),
  },
  dateSelectorContainer: {
    display: "none",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
    width: "100%",
  },
});

export default styles;
